import { VisibilityOff } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, CircularProgress, styled } from "@mui/material";

import type { ExtraImageButtonProps } from "./types";

const StyledButton = styled(Button)({
  textAlign: "left",
  fontSize: "0.75rem",
  transition: "all 0.2s ease-in-out",
  width: "100%",
  "&:hover": {
    transform: "scale(1.02)",
  },
});

export function ExtraImageButton({
  loading,
  isSuccess,
  handleImageClick,
  image,
  index,
  extraImageUrl,
}: ExtraImageButtonProps) {
  return (
    <StyledButton
      onClick={handleImageClick}
      endIcon={
        loading ? (
          <CircularProgress size={16} color="inherit" />
        ) : extraImageUrl ? (
          <VisibilityIcon />
        ) : (
          <VisibilityOff sx={{ color: "gray" }} />
        )
      }
      size="small"
      variant={extraImageUrl ? "contained" : "outlined"}
      color={isSuccess ? "success" : "primary"}
      fullWidth
      disabled={loading}
    >
      {`${index + 1}: ${image}`}
    </StyledButton>
  );
}
